/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as n from "react";
import { useDocument as c } from "./useDocument.mjs";
const i = (e) => {
  const o = c(e);
  return n.useCallback(() => {
    const t = o();
    return t && t.defaultView || window;
  }, [o]);
};
export {
  i as useWindow
};
